import * as React from 'react';
import WifiIcon from '@mui/icons-material/Wifi';
import AirIcon from '@mui/icons-material/Air';
import PoolIcon from '@mui/icons-material/Pool';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import BathtubIcon from '@mui/icons-material/Bathtub';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import HotTubIcon from '@mui/icons-material/HotTub';
import BedroomBabyIcon from '@mui/icons-material/BedroomBaby';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import TvIcon from '@mui/icons-material/Tv';
import CribIcon from '@mui/icons-material/Crib';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import KayakingIcon from '@mui/icons-material/Kayaking';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import CoffeeMakerIcon from '@mui/icons-material/CoffeeMaker';
import LockIcon from '@mui/icons-material/Lock';
import LuggageIcon from '@mui/icons-material/Luggage';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import PetsIcon from '@mui/icons-material/Pets';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import EvStationIcon from '@mui/icons-material/EvStation';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SpaIcon from '@mui/icons-material/Spa';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import BalconyIcon from '@mui/icons-material/Balcony';
import BlenderIcon from '@mui/icons-material/Blender';

export const roomServices = [
    {
        service: 'WifiIcon',
        descripcion: 'Wifi',
        icon: <WifiIcon />,
    },
    {
        service: 'AirIcon',
        descripcion: 'Aire acondicionado',
        icon: <AirIcon />,
    },
    {
        service: 'PoolIcon',
        descripcion: 'Piscina',
        icon: <PoolIcon />,
    },
    {
        service: 'BathtubIcon',
        descripcion: 'Bañera',
        icon: <BathtubIcon />,
    },
    {
        service: 'FreeBreakfastIcon',
        descripcion: 'Desayuno',
        icon: <FreeBreakfastIcon />,
    },
    {
        service: 'BeachAccessIcon',
        descripcion: 'Accesorios de playa',
        icon: <BeachAccessIcon />,
    },
    {
        service: 'HotTubIcon',
        descripcion: 'Hot Tub',
        icon: <HotTubIcon />,
    },
    {
        service: 'BedroomBabyIcon',
        descripcion: 'Guarderia',
        icon: <BedroomBabyIcon />,
    },
    {
        service: 'CleaningServicesIcon',
        descripcion: 'Limpieza',
        icon: <CleaningServicesIcon />,
    },
    {
        service: 'LocalLaundryServiceIcon',
        descripcion: 'Lavanderia',
        icon: <LocalLaundryServiceIcon />,
    },
    {
        service: 'TvIcon',
        descripcion: 'TV',
        icon: <TvIcon />,
    },
    {
        service: 'CribIcon',
        descripcion: 'Cuna',
        icon: <CribIcon />,
    },
    {
        service: 'DirectionsBikeIcon',
        descripcion: 'Bicicleta',
        icon: <DirectionsBikeIcon />,
    },
    {
        service: 'FitnessCenterIcon',
        descripcion: 'Gimnasio',
        icon: <FitnessCenterIcon />,
    },
    {
        service: 'RestaurantIcon',
        descripcion: 'Restaurante',
        icon: <RestaurantIcon />,
    },
    {
        service: 'FireplaceIcon',
        descripcion: 'Estufa',
        icon: <FireplaceIcon />,
    },
    {
        service: 'OutdoorGrillIcon',
        descripcion: 'Grill',
        icon: <OutdoorGrillIcon />,
    },
    {
        service: 'KayakingIcon',
        descripcion: 'Kayak',
        icon: <KayakingIcon />,
    },
    {
        service: 'LocalBarIcon',
        descripcion: 'Bar',
        icon: <LocalBarIcon />,
    },
    {
        service: 'CoffeeMakerIcon',
        descripcion: 'Cafetera',
        icon: <CoffeeMakerIcon />,
    },
    {
        service: 'LockIcon',
        descripcion: 'Caja de seguridad',
        icon: <LockIcon />,
    },
    {
        service: 'LuggageIcon',
        descripcion: 'Equipaje',
        icon: <LuggageIcon />,
    },
    {
        service: 'LocalParkingIcon',
        descripcion: 'Estacionamiento',
        icon: <LocalParkingIcon />,
    },
    {
        service: 'PetsIcon',
        descripcion: 'Pet Friendly',
        icon: <PetsIcon />,
    },
    {
        service: 'SportsTennisIcon',
        descripcion: 'Tenis',
        icon: <SportsTennisIcon />,
    },
    {
        service: 'EvStationIcon',
        descripcion: 'Carga Electrica',
        icon: <EvStationIcon />,
    },
    {
        service: 'SportsEsportsIcon',
        descripcion: 'Videojuegos',
        icon: <SportsEsportsIcon />,
    },
    {
        service: 'SpaIcon',
        descripcion: 'Spa',
        icon: <SpaIcon  />,
    },
    {
        service: 'RoomServiceIcon',
        descripcion: 'Room Service',
        icon: <RoomServiceIcon   />,
    },
    {
        service: 'BlenderIcon',
        descripcion: 'Licuadora',
        icon: <BlenderIcon   />,
    },
    {
        service: 'BalconyIcon',
        descripcion: 'Balcon',
        icon: <BalconyIcon   />,
    },
];